module.exports = __webpack_public_path__ + "static/img/signupbg.1aca5d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Signup/signupbg.svg
// module id = 7X7g
// module chunks = 37